import { Injectable } from '@angular/core';
import { Language, LanguageResponse, LanguageSubjectModel } from './language-switcher.model';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { BaseService } from '../../services/base.service';
import { SettingsService } from '../../services/settings.service';
import { Languages } from '../../../login/login.viewmodel';

@Injectable({
  providedIn: 'root'
})
export class LanguageSwitcherService {
  private languageSubject = new BehaviorSubject<LanguageSubjectModel>(null);
  public languageStatus$ = this.languageSubject.asObservable();
  
  constructor(protected baseService: BaseService, private settingsService: SettingsService) { }


  getLanguages(): Observable<LanguageResponse> {
    // let url = `${this.settingsService.GDRP_API_URL}/user/getUserRoles`;
    let url: string = '/v1/lpmi/portal/getLpmiLanguages';
    //return of(this.getMockedLanguages());
    return this.baseService.get<LanguageResponse>(`${url}`, 'API').pipe(
      tap((response: LanguageResponse) => {
        response;
      })
    );
  }

  // getLanguages(): Observable<LanguageResponse> {
  //   return of(this.getMockedLanguages());
  // } 

  setLanguageStatus(langugaeSubjectModel: LanguageSubjectModel) {
    this.languageSubject.next(langugaeSubjectModel);
  }

  // getMockedLanguages(): LanguageResponse {
  //   return this.mockedLanguages;
  // }
}
